import { apiService } from './api.service';

/** Backend AnnouncementCategory ile birebir. */
export const ANNOUNCEMENT_CATEGORY = {
    DUYURU: 0,
    KAMPANYA: 1,
    YENILIK: 2,
    BAKIM: 3,
};

/** Kategori → renk/etiket. Rozetin ağ yanıtına bağlı kalmaması için burada durur. */
export const categoryVisual = (category) => {
    switch (category) {
        case ANNOUNCEMENT_CATEGORY.KAMPANYA:
            return { color: '#a855f7', bg: 'rgba(168,85,247,0.14)', label: 'Kampanya' };
        case ANNOUNCEMENT_CATEGORY.YENILIK:
            return { color: '#22c55e', bg: 'rgba(34,197,94,0.14)', label: 'Yenilik' };
        case ANNOUNCEMENT_CATEGORY.BAKIM:
            return { color: '#f59e0b', bg: 'rgba(245,158,11,0.14)', label: 'Bakım' };
        default:
            return { color: '#3b82f6', bg: 'rgba(59,130,246,0.14)', label: 'Duyuru' };
    }
};

export const announcementService = {
    list: () => apiService.get('/api/announcement'),

    /**
     * Açılışta gösterilecek tek duyuru; yoksa data null döner.
     * Hata da yutulur — duyuru yüzünden panel açılışı kesilmemeli.
     */
    popup: async () => {
        try {
            return await apiService.get('/api/announcement/popup');
        } catch {
            return { success: false };
        }
    },

    /** Okundu işaretler. Sunucuda idempotent; hata kullanıcıya yansıtılmaz. */
    markRead: async (id) => {
        try {
            await apiService.post(`/api/announcement/${id}/read`);
        } catch {
            // Yut: popup yine kapanır, bir sonraki açılışta tekrar çıkar.
        }
    },
};
